import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../pages/selectors";
import { roleValues } from "../constants/roles";

interface Props {
  roles: roleValues[];
}

export const PrivateRoute = ({ roles }: Props) => {
  const user = useSelector(getUser);

  const isLoggedIn = !!user;
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const isRouteAvailable = roles.includes(user.role);

  return isLoggedIn && isRouteAvailable ? <Outlet /> : <Navigate to="/tenants" replace />;
};
